module.exports = __webpack_public_path__ + "img/ico-pay-offline.fd9dc806.svg";